<template>
<div>

  <div class="header-banner">
    <section class="section header-block">
      <div class="container">
      <h1>Blog</h1>
    </div>
  </section>
  </div>

  <section class="section">

        <div class="container">
            <BlogRows :blogs="blogs" :blogslist="blogs" />
        </div>  

        <!-- <div class="container">
            <nav class="pagination is-centered">
                <ul class="pagination-list">
                    <li>
                        {{currentPage+1 }} / {{ pages }}
                    </li>
                </ul>
                <div class="page-item" :class="{disabled: prevUrl === ''}">
                    <button class="pagination-previous" @click="checkPage(prevUrl)">Previous</button>
                </div>
                <div class="page-item" :class="{disabled: nextUrl === ''}">
                    <button class="pagination-next" @click="checkPage(nextUrl)">Next</button>
                </div>
            </nav>
        </div> -->
  </section>
</div>
</template>

<script>
import BlogRows from './cards/BlogRows';
import Api from '@/config/Api'

export default {
    components: {
        BlogRows
    },
    data() {
        return {
            blogs: [],
            currentPage: '',
            pages: '',
            prevUrl: '',
            nextUrl: ''
        }
    },
    /* computed: {
        country() {
            return this.$store.getters.getCountry
        }
    }, */
    created() {
        Api().get(`/api/blogs`).then(response => {
            this.blogs = response.data.blogs;
            /* this.currentPage = response.data.currentPage;
            this.pages = response.data.pages;
            this.nextUrl = response.data.nextUrl;
            this.prevUrl = response.data.prevUrl; */
            console.log("blogs created", this.blogs);
            this.$store.commit('setContentLoaded', true); // then footer will be displayed
        });
    },
    methods: {
        /* checkPage(url) {
            Api().get(url).then(response => {
                console.log("checkPage url:",url);
                this.blogs = response.data.blogs;
                this.currentPage = response.data.currentPage;
                this.pages = response.data.pages;
                this.nextUrl = response.data.nextUrl;
                this.prevUrl = response.data.prevUrl;
                window.scrollTo(0, 0);
            })
        } */
    },
    metaInfo: {
      title: "Blog",
      // titleTemplate: null // override the parent template and just use the above title only
    }
}
</script>

<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/Blogs.vue